import axiosGlobal, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Constants, RouteConstants } from "../constants";
import authService from "../services/authentication.service";
import { shouldAttachAccessToken, shouldLogoutOnUnauthorized } from "../utils/authorizationUtil";
import LocalStorageUtil from "../utils/localStorage";
import logger from "../utils/logger";
import { browserHistory } from "../utils/routes.util";

// TODO: Uncomment
// axiosGlobal.defaults.timeout = 6000;

const extractAndSaveToken = (response: AxiosResponse<any>) => {
  if (
    !response.headers.authorization ||
    // No need to save token for view ecg path
    browserHistory?.location?.pathname?.indexOf(
      RouteConstants.VIEW_ECG_PATH
    ) !== -1 || browserHistory?.location?.pathname?.indexOf(
      RouteConstants.VIEW_PRESCRIPTION_PATH
    ) !== -1
  ) {
    return;
  }

  const token = response.headers.authorization.split(" ")[1];
  LocalStorageUtil.set(Constants.JWT_KEY, token);
};

const requestInterceptor = (request: AxiosRequestConfig) => {
  if (shouldAttachAccessToken(browserHistory?.location?.pathname)) {
    const token = LocalStorageUtil.get(Constants.JWT_KEY);
    request.headers["Authorization"] = `Bearer ${token}`;
  }

  request.headers["Device-Type"] = "sh_dt_portal";

  return request;
};

const responseInterceptor = (response: AxiosResponse<any>) => {
  extractAndSaveToken(response);
  return response;
};

axiosGlobal.interceptors.request.use(requestInterceptor, (error) => {
  logger.error("Interceptors request error:", error);
  return Promise.reject(error);
});

axiosGlobal.interceptors.response.use(responseInterceptor, (error) => {
  logger.error("Interceptors response error:", error);
  extractAndSaveToken(error?.response);

  // Navigate to login on Unauthorized (401) - if route is NOT login && NOT change_password && NOT view_ecg && NOT reset_password.
  if (error.response.status === 401 && shouldLogoutOnUnauthorized(browserHistory?.location?.pathname)) {
    authService.logout("expired_token");
  }

  return error?.response ?? Promise.reject(error);
});
